interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  const btnBase =
    "flex items-center justify-center min-w-9 h-9 px-3 rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap";

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap mt-10">
      <button
        type="button"
        aria-label="上一页"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className={`${btnBase} border border-background-300 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((page) => (
        <button
          key={page}
          type="button"
          aria-label={`第 ${page} 页`}
          onClick={() => onPageChange(page)}
          className={`${btnBase} ${
            page === currentPage
              ? "bg-primary-500 text-background-50"
              : "border border-background-300 text-foreground-600 hover:bg-background-100"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        type="button"
        aria-label="下一页"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        className={`${btnBase} border border-background-300 text-foreground-600 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}